import styled from 'styled-components';

export const StyledSafetyTrainingDetailModal = styled.div``;
